import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ requiredLevel = 0, loginPath = "/login" }) => {
	const storedAccount = localStorage.getItem("account");

	if (!storedAccount) return <Navigate to={loginPath} replace />;

	try {
		const parsedAccount = JSON.parse(storedAccount);

		if (parsedAccount && parsedAccount.id && Number(parsedAccount.level) === requiredLevel) {
			return <Outlet />;
		} else {
			return <Navigate to={loginPath} replace />;
		}
	} catch (e) {
		return <Navigate to={loginPath} replace />;
	}
};

export default PrivateRoute;
